import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/daf645d9-2ce5-4aba-9bc0-7c95b401c6c8",
        "alt": "An image displaying each header from h1 to h6."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Headings are used to structure the content on the page, with each heading representing a different level of importance. It is recommended to use headings in a logical manner to create a clear hierarchy and improve accessibility.`}</p>
    <ul>
      <li parentName="ul">{`Heading should be used to communicate page organization and hierarchy.`}</li>
      <li parentName="ul">{`Use heading as the title that introduces a page, a section or an article.`}</li>
      <li parentName="ul">{`The heading component will render an html h2 tag without any default styling.`}</li>
    </ul>
    <h2>{`Options`}</h2>
    <h3>{`Scale and size`}</h3>
    <p>{`The heading scale ranges from 1 to 6 and maps to the HTML heading elements h1 to h6 respectively. The size is determined by the type of HTML element specified, although you can override this when the scenario calls for it. E.g. use a `}<inlineCode parentName="p">{`h2`}</inlineCode>{` heading size on a `}<inlineCode parentName="p">{`<h3>`}</inlineCode>{` to highlight an article that might be relevant to the user.`}</p>
    <h3>{`Weight, stretch and letter spacing`}</h3>
    <p>{`The heading component also supports the following options: `}<inlineCode parentName="p">{`weight`}</inlineCode>{`, `}<inlineCode parentName="p">{`stretch`}</inlineCode>{` and `}<inlineCode parentName="p">{`letterSpacing`}</inlineCode>{`. Each of these options are determined by the heading scale and size, but can be overridden when the scenario calls for it.`}</p>
    <h3>{`Responsive`}</h3>
    <p>{`The heading component is responsive by default and the size will scale down on smaller screens. Weight, stretch and letter spacing will remain the same across all screen sizes but can be overridden for each breakpoint.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/d0e7ef2b-d52f-413e-8580-579a9129696c" mdxType="CustomVideoPlayer" />
    </div>
    <h2>{`Accessibility`}</h2>
    <p>{`While sighted users rely on visual cues such as font size changes to determine what the heading is, assistive technology users rely on programatic cues that can be read out. When text on a page is visually implied to be a heading, ensure that it is coded as a heading. Additionally, visually implied heading level and coded heading level should be consistent. See `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/WCAG21/Understanding/info-and-relationships.html"
      }}>{`WCAG success criteria: 1.3.1: Info and Relationships`}</a>{`.`}</p>
    <p>{`Headings allow assistive technology users to quickly navigate around a page. Navigation as text that is not meant to be a heading can be a confusing experience. `}<a parentName="p" {...{
        "href": "https://www.w3.org/WAI/tutorials/page-structure/headings/"
      }}>{`Learn more about best heading practices (WAI Headings)`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/1fe099cf-a6ea-4e1f-9f6b-8ee7aebefd06" />
    <Caption mdxType="Caption">
      Use headings with a lower rank to start new subsections that are part of
      the higher ranked section.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/2b74dd50-fab8-4a6c-8661-71ecfa94de9c" />
    <Caption mdxType="Caption">
      Don't skip heading ranks. Make sure that a h2 is not followed directly by
      an h4, for example.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Text"
        }}>{`Text`}</a>{`: to render body content`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      